module.exports = __webpack_public_path__ + "img/d04.bb4eecdb.png";